import { TestExamService } from "@/common/api.service"
import { TestExamModuleService } from "@/common/api.service"
import { TestDetailService, ExamDetailService } from "@/common/api.service"

import { FETCH_TEST_EXAM, FETCH_INDIVIDUAL_TEST_EXAM, FETCH_DETAILED_INDIVIDUAL_TEST_RESULTS, FETCH_DETAILED_INDIVIDUAL_EXAM_RESULTS, FETCH_ALL_TESTS, FETCH_ALL_EXAMS, TEST_EXAM_RESET_STATE} from "./actions.type"
import { SET_TEST_EXAM, SET_TEST_DATA, SET_EXAM_DATA, SET_INDIVIDUAL_TEST_EXAM, SET_DETAILED_INDIVIDUAL_TEST_EXAM, SET_ERROR_TEST_EXAM, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        testexams: [],
        individualtestexam: [],
        testexamerrors: null,

        testdata: [],
        examdata: [],
        detailedindividualtestexam: [],
    }
}

let state = initialState()

const getters = {
    testexams(state) {
        return state.testexams
    },
    individualtestexam(state) {
        return state.individualtestexam
    },
    testdata(state) {
        return state.testdata
    },
    examdata(state) {
        return state.examdata
    },
}

const actions = {
    async [FETCH_TEST_EXAM](context, slug) {
        
        if(slug.includes("test")){
            const { data } = await TestExamService.getTestUserResults(slug)
            context.commit(SET_TEST_EXAM, data.data)
            context.commit(SET_TEST_DATA, data.data)
            return data;
        }
        else if(slug.includes("exam")){
            const { data } = await TestExamService.getExamUserResults(slug)
            context.commit(SET_TEST_EXAM, data.data)
            context.commit(SET_EXAM_DATA, data.data)
            return data;
        }
    },

    async [FETCH_INDIVIDUAL_TEST_EXAM](context, slug) {
        if(slug.includes("test")){
            const { data } = await TestExamModuleService.getTest(slug)
            context.commit(SET_INDIVIDUAL_TEST_EXAM, data.data)
            return data;
        }
        else{
            const { data } = await TestExamModuleService.getExam(slug)
            context.commit(SET_INDIVIDUAL_TEST_EXAM, data.data)
            return data;
        }
    }, 

    async [FETCH_DETAILED_INDIVIDUAL_TEST_RESULTS](context, slug) {
        const { data } = await TestDetailService.get(slug)
        context.commit(SET_DETAILED_INDIVIDUAL_TEST_EXAM, data.data)
        return data;
    }, 
    async [FETCH_DETAILED_INDIVIDUAL_EXAM_RESULTS](context, slug) {
        const { data } = await ExamDetailService.get(slug)
        context.commit(SET_DETAILED_INDIVIDUAL_TEST_EXAM, data.data)
        return data;
    },  

    async [FETCH_ALL_TESTS](context, slug) {
        const { data } = await TestExamService.getTests(slug)
        context.commit(SET_TEST_DATA, data.data)
        return data;
    },
    async [FETCH_ALL_EXAMS](context, slug) {
        const { data } = await TestExamService.getExams(slug)
        context.commit(SET_TEST_DATA, data.data)
        return data;
    },
    
    [TEST_EXAM_RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_TEST_EXAM](state, error) {
        state.testexamerrors = error
    },      
    [SET_TEST_EXAM](state, testdata) {
        state.testexams = testdata
    },
    [SET_TEST_DATA](state, testdata) {
        state.testdata = testdata
    },
    [SET_EXAM_DATA](state, testdata) {
        state.examdata = testdata
    },
    [SET_INDIVIDUAL_TEST_EXAM](state, individualtestexam) {
        state.individualtestexam = individualtestexam
    }, 
    [SET_DETAILED_INDIVIDUAL_TEST_EXAM](state, individualtestexam) {
        state.detailedindividualtestexam = individualtestexam
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};